
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution-contents/vendors/[slug]",
      function () {
        return require("private-next-pages/solution-contents/vendors/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solution-contents/vendors/[slug]"])
      });
    }
  